<h3>{{'events.prediction_tags' | translate}} <br>
    <span class="tag-count" *ngIf="taggedCount">
        {{taggedCount}}
        {{'events.tagged_image' | translate}}
    </span>
</h3>

<div class="tag" *ngIf="module== 'crane'">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{'form.name' | translate}}</mat-label>
        <input matInput [(ngModel)]="newTag" type="text" class="tag-input" />
    </mat-form-field>

    <lib-button color="primary" icon="add" (click)="addTag()" tooltip="{{'form.add' | translate}}">
    </lib-button>
</div>

<table mat-table [dataSource]="tagsData" matSort class="table-tags">
    <ng-container matColumnDef="enable">
        <th mat-header-cell *matHeaderCellDef>
            <div class="checkbox-header">
                <mat-checkbox class="check-enable" [(ngModel)]="selectAllEnabled"
                    (change)="toggleSelectAll($event)"></mat-checkbox>
                <span>{{ 'settings.enable' | translate }}</span>
            </div>
        </th>

        <td mat-cell *matCellDef="let tag">
            <mat-checkbox [(ngModel)]="tag.enabled" [checked]="isTagEnabled(tag.name)" (change)="toggleTagEnable(tag)">
            </mat-checkbox>
        </td>
    </ng-container>

    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="header-content">
                <mat-icon>label</mat-icon>
                {{'datatable.name'|translate}}
            </div>
        </th>

        <td mat-cell *matCellDef="let tag">
            <div class="cell-radio">
                <input type="radio" name="mergeTag" class="radio" [ngClass]="{'merging': isMergeInProgress}"
                    [(ngModel)]="selectedTag" [value]="tag" [disabled]="tag.editable">
                <label>{{ tag.name }}</label>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="displayName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="header-content">
                <mat-icon>text_fields</mat-icon>
                {{'form.displayName'|translate}}
            </div>
        </th>

        <td mat-cell *matCellDef="let tag">
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-label>{{'form.displayName' | translate}}</mat-label>
                <input matInput [(ngModel)]="tag.displayName" (blur)="onDisplayNameChange()"
                    [placeholder]="tag.defaultDisplayName || tag.name">
            </mat-form-field>
        </td>
    </ng-container>

    <ng-container matColumnDef="countTag">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="header-content">
                <mat-icon>numbers</mat-icon>
                {{'datatable.countTag'|translate}}
            </div>
        </th>

        <td mat-cell *matCellDef="let tag">
            {{tag?.count}}
        </td>
    </ng-container>

    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <div class="header-content">
                <mat-icon>edit</mat-icon>
                Action
            </div>
        </th>

        <td mat-cell *matCellDef="let tag">
            <!-- Mode normal : bouton Fusionner -->
            <lib-button
                *ngIf="tag.editable && isPrivileged() && (!isMergeInProgress || mergeInProgressTag !== tag)"
                color="none" class="button-tag" (click)="mergeTag(tag)" size="medium" icon="merge" tooltip="Fusionner"
                textColor="secondary">
            </lib-button>

            <!-- Mode fusion : bouton Annuler -->
            <lib-button *ngIf="tag.editable && isMergeInProgress && mergeInProgressTag === tag" color="none"
                class="button-tag" (click)="cancelMerge()" size="medium" icon="cancel" tooltip="Annuler"
                textColor="danger">
            </lib-button>

            <!-- Mode fusion : bouton Fusion + ML -->
            <lib-button *ngIf="tag.editable && isMergeInProgress && mergeInProgressTag === tag" color="secondary"
                class="button-tag" (click)="confirmMerge(tag, true)" size="medium" icon="psychology"
                text="Fusion + machine learning">
            </lib-button>

            <!-- Bouton Supprimer (mode normal) -->
            <lib-button *ngIf="tag.editable && (!isMergeInProgress || mergeInProgressTag !== tag)" color="none"
                class="button-tag" (click)="removeTag(tag.name)" size="medium" icon="delete" tooltip="Supprimer"
                textColor="danger">
            </lib-button>

            <!-- Bouton Fusionner (mode fusion) -->
            <lib-button *ngIf="tag.editable && isMergeInProgress && mergeInProgressTag === tag" color="secondary"
                class="button-tag" (click)="confirmMerge(tag, false)" size="medium" icon="call_merge" text="Fusion">
            </lib-button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="tagsColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: tagsColumns;"></tr>
</table>

<div *ngIf="loading" class="loading">
    <mat-spinner diameter="50" class="example-spinner">
        <mat-icon class="example-icon">loop</mat-icon>
    </mat-spinner>
</div>